module.exports = __webpack_public_path__ + "4fda9d8f4dd1458f7f3b27d7e238d18b.svg";